import { render, staticRenderFns } from "./RecordTaskRelationTagList.vue?vue&type=template&id=6746a247&scoped=true&"
import script from "./RecordTaskRelationTagList.vue?vue&type=script&lang=js&"
export * from "./RecordTaskRelationTagList.vue?vue&type=script&lang=js&"
import style0 from "./RecordTaskRelationTagList.vue?vue&type=style&index=0&id=6746a247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746a247",
  null
  
)

export default component.exports